<template>
  <div :class="rotation">
    <VueBarcode :value="barcode" 
                :format="format===''? undefined :format"
                width="2" 
                height="80"
                font="Times new roman"
                font-size="12px"
    />
  </div>
</template>

<script>
import VueBarcode from 'vue-barcode'
export default {
  name:'Barcode',
  components:{VueBarcode},
  props:{
     rotate: { type: Number, required: true },
     format: { type: String, required:false, default:''},
     customerId: { type: String, required:false, default:''},
     bundleId: { type: String, required:false, default:''}
  },  

  computed:{
    barcode(){
      return this.zeroFill(this.customerId,5) + this.zeroFill(this.bundleId,5)
    },
    rotation(){  
      return 'barcode-container-'+ this.rotate      
    }
  },
  mounted(){    
    console.log('barcode Emit ' + this.bundleId)
    this.$emit('barcode', this.bundleId)
    
  },
  methods:{
     zeroFill( number, width )
    {
      width -= number.toString().length
      if ( width > 0 )
      {
        return new Array( width + (/\./.test( number ) ? 2 : 1) ).join( '0' ) + number
      }
      return number + '' // always return a string
    }
  }}
</script>

<style>
  .barcode-container-90{
    display: inline-block;
    transform: rotate(90deg);
  }
  .barcode-container-180{
    display: inline-block;
    transform: rotate(180deg);
  }
  .barcode-container-270{
    display: inline-block;
    transform: rotate(270deg);
  }
</style>
format: { type: String, required:false, default:''}